import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    name,
    desc,
    formConfig = {},
    widgetData = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.dynamicTable.saveFormConfig, {
        id,
        name,
        desc,
        formConfig,
        widgetData,
    }, options);
    if (error) return { error, status };
    return content || {};
};

